import { css } from 'styled-components';
import is from 'styled-is';

import { gridSizes, colorSchema } from 'utils/style';

const baseItemStyles = css`
  height: 56px;
  text-decoration: none;
  padding: 0 ${gridSizes('M')};
  -webkit-appearance: none;
  border: none;
  text-align: left;
  width: 100%;
  outline: none;
  cursor: pointer;
  background: #fff;

  &:hover {
    background: ${colorSchema('primary100')};
  }

  ${is('active')`
    background: ${colorSchema('primary100')};
  `};
`;

export default baseItemStyles;
